import DateVO from '../../../../vo/DateVO'

const INTERNAL_YEARMONTH_FORMAT: string = 'YYYY/MM'
const DATE_FORMAT_REGEX = /^\d{4}\/\d{2}\/\d{2}$/
const YEAR_MONTH_REGEX = /^(\d{4}\/\d{2})\/\d{2}$/

export const isDateFormat = (key: string): boolean => {
  return DATE_FORMAT_REGEX.test(key)
}

export const isMonthFirstDay = (key: string): boolean => {
  return key.endsWith('/01')
}

export const isWeekPeriod = (key: string): boolean => {
  return isDateFormat(key) && !isMonthFirstDay(key)
}

export const extractYearMonth = (dateKey: string): string | null => {
  const match = dateKey.match(YEAR_MONTH_REGEX)
  return match ? match[1] : null
}

const isCurrentMonth = (date: DateVO, now: DateVO): boolean => {
  return (
    date.format(INTERNAL_YEARMONTH_FORMAT) ===
    now.format(INTERNAL_YEARMONTH_FORMAT)
  )
}

const isCurrentWeek = (weekStart: DateVO, now: DateVO): boolean => {
  const weekEnd = weekStart.addDays(6)
  const nowValue = now.getValue()
  return nowValue >= weekStart.getValue() && nowValue <= weekEnd.getValue()
}

export const isCurrentPeriod = (dateKey: string): boolean => {
  const now = DateVO.now()

  if (isDateFormat(dateKey)) {
    const date = new DateVO(dateKey)

    if (isMonthFirstDay(dateKey)) {
      return isCurrentMonth(date, now)
    }

    return isCurrentWeek(date, now)
  }

  return dateKey === now.format(INTERNAL_YEARMONTH_FORMAT)
}
